import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';

// i18n
import { withTranslation } from 'react-i18next';

// redux
import { push } from '../../../navigation';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import {
  clearBroadcastMessages,
  fetchBroadcastMessages
} from '../../../modules/message';

import { authUtil } from '../../../utils';
import { PaddedWrapper } from '../../../style';

export class BroadcastMessageList extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.fetchBroadcastMessages();
  }

  componentWillUnmount() {
    this.props.clearBroadcastMessages();
  }

  fetchBroadcastMessages = async () => {
    const { currentBook } = this.props;
    const idToken = await authUtil.getFreshIdToken();
    this.props.fetchBroadcastMessages({ idToken, bookId: currentBook._id })
  }

  openMessage = (event) => {
    const { currentBook } = this.props;
    const { messageId } = event.currentTarget.dataset;
    this.props.changePage(`/books/${currentBook._id}/messages/${messageId}`)
  }

  render() {
    const { t, currentBook, broadcastMessages } = this.props;
    // const readOnly = !accessUtil.isAllowed(currentBook.access, ['edit']);
    if (!currentBook) return null;

    return (
      <PaddedWrapper>
        <table className="br-table" aria-label={t('Messages', 'Messages')}>
          <thead>
            <tr>
              <th scope="col">{t('Title')}</th>
              <th scope="col">{t('Sent')}</th>
            </tr>
          </thead>
          <tbody>
            {
              broadcastMessages && broadcastMessages.map(message => (
                <tr key={message._id}>
                  <td><button type="button" className="br-broadcast-list__open"
                    data-message-id={message._id} onClick={this.openMessage}>
                    {message.title}
                  </button></td>
                  <td><time dateTime={message.sentAt}>{moment(message.sentAt).format('ll')}</time></td>
                </tr>
              ))
            }
          </tbody>
        </table>
      </PaddedWrapper>
    );
  }
}


// redux stuff
const mapStateToProps = state => ({
  user: state.user.user,
  idToken: state.user.idToken,
  userProfile: state.user.userProfile,
  currentBook: state.book.currentBook,
  broadcastMessages: state.message.broadcastMessages,
  fetchingBroadcastMessages: state.message.fetchBroadcastMessages
});

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: newPage => push(newPage),
  clearBroadcastMessages,
  fetchBroadcastMessages
}, dispatch);

export default withTranslation()(withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(BroadcastMessageList)));
